module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        " + _vm._s(_vm.heading) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('count-to', {
    attrs: {
      "startVal": 0,
      "endVal": parseInt(_vm.number, 10),
      "duration": 2000
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-06a459bd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06a459bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/SummaryCard.vue
// module id = 777
// module chunks = 0